import WorkspaceDialog from './WorkspaceDialog';
import { Icon } from './JournalOverview';

export default function DeleteConfirmation({ message, onCancel, onConfirm }) {
  const recoverable = /Recently Deleted/i.test(message);
  return <WorkspaceDialog title={recoverable ? 'Move trade to Recently Deleted?' : 'Delete this item?'} className="tl-delete-confirmation" onClose={onCancel}>
    <div className="tl-delete-emblem" aria-hidden="true"><Icon name="trash" size={24}/></div>
    <p>{message}</p>
    {recoverable && <div className="tl-delete-recovery"><Icon name="history" size={17}/><span>Your notes and charts stay recoverable for 5 days.</span></div>}
    <div className="tl-delete-actions"><button type="button" data-autofocus className="tl-btn" onClick={onCancel}>Keep it</button><button type="button" className="tl-btn tl-btn-danger" onClick={onConfirm}>{recoverable ? 'Move to deleted' : 'Delete item'}</button></div>
  </WorkspaceDialog>;
}
